<h2 mat-dialog-title>
  {{ "inspectionReportConfirmationDialog.confirmation" | translate }}
</h2>
<div class="container" fxLayout="column" fxLayoutAlign="center center">
  <p>{{ "inspectionReportConfirmationDialog.message" | translate }}</p>
</div>
<div class="container" fxLayout="row" fxLayoutAlign="center center" position="fixed">
  <mat-dialog-actions fxFlex fxLayoutAlign="center center">
    <button mat-button color="primary" (click)="this.dialogRef.close(false)">
      {{ "inspectionReportConfirmationDialog.noToInclude" | translate }}
    </button>
    <button mat-raised-button color="primary" [mat-dialog-close]="true" (click)="this.dialogRef.close(true)">
      {{ "inspectionReportConfirmationDialog.yesToInclude" | translate }}
    </button>
  </mat-dialog-actions>
</div>
